// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_address_street = /** @type {(inputs: {}) => string} */ () => {
	return `27, 25th March Street`
};

const el_address_street = /** @type {(inputs: {}) => string} */ () => {
	return `27, 25ης Μαρτίου`
};

const ru_address_street = /** @type {(inputs: {}) => string} */ () => {
	return `27, 25th March Street`
};

const he_address_street = /** @type {(inputs: {}) => string} */ () => {
	return `27, 25th March Street`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const address_street = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.address_street(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("address_street", locale)
	if (locale === "en") return en_address_street(inputs)
	if (locale === "el") return el_address_street(inputs)
	if (locale === "ru") return ru_address_street(inputs)
	if (locale === "he") return he_address_street(inputs)
	return "address_street"
};